import { Appear, Button, Buttons, Flex, FlexProps, Icon, Text } from '@bitrise/bitkit';
import React, { FunctionComponent } from 'react';

import dataAtIds from '../../dataAtIds.json';
import useSession from './useSession';
import SessionAttributes from './SessionAttributes';
import SessionInteractions from './SessionInteractions';

interface Props extends FlexProps {
  id: string;
  onNextSessionClick?: () => void;
}

const SessionViewer: FunctionComponent<Props> = ({ id, onNextSessionClick, ...rest }) => {
  const { isFetching, isError, metrics, session } = useSession(id);

  if (isError) {
    return (
      <Flex alignChildrenVertical="middle" direction="vertical" grow>
        <Appear animation="Fade" textColor="red-3">
          <Flex alignChildren="middle" direction="vertical" height="100%">
            <Flex>
              <Flex alignChildren="middle" direction="vertical">
                <Icon margin="x1" name="BitbotFailed" size="3rem" />
              </Flex>
              <Flex direction="vertical" gap="x6">
                <Text align="middle" ellipsis>
                  Sorry, we were unable to locate data for this session.
                  {onNextSessionClick && ' Please try the next session.'}
                </Text>

                {onNextSessionClick && (
                  <Buttons alignChildrenHorizontal="middle">
                    <Button type="button" size="small" onClick={onNextSessionClick}>
                      <Text>Next session</Text>
                      <Icon name="ArrowForward" />
                    </Button>
                  </Buttons>
                )}
              </Flex>
            </Flex>
          </Flex>
        </Appear>
      </Flex>
    );
  }

  return (
    <Flex {...rest} data-trace-at-id={dataAtIds.SessionExplorer}>
      <SessionAttributes
        attributes={session.attributes}
        duration={session.durationMs}
        isFetching={isFetching}
        timestamp={session.start}
      />

      <SessionInteractions isFetching={isFetching} metrics={metrics} session={session} />
    </Flex>
  );
};

export default SessionViewer;
